<template>
  <v-app>
    <div class="padding-card-c grey">
      <v-card>
        <div class="padding-card-c">
          <NotificationForm @on-save="getNotifications" />
        </div>
      </v-card>
      <p class="title-user-scr-b" style="padding-top: 50px"> Últimas notificaciones enviadas </p>
      
        <v-col v-for="(item, i) in shownCards" :key="i" cols="12">
         
          <v-card color="white">
            <div class="d-flex justify-space-between">
              <v-list-item>
                <v-list-item-avatar>
                  <img alt="" :src="imageDefaul" />
                </v-list-item-avatar>

                <v-list-item-content style="margin-left: 15px">
                  <v-list-item-title class="title-text-info"> {{ item.title }} </v-list-item-title>
                  <v-list-item-title class="subtitle" v-if="item.recipient">Enviado a: {{ item.recipient.username }} </v-list-item-title>
                  <v-list-item-title class="subtitle" v-else> Enviado a: Todos </v-list-item-title>
                  <span> {{ item.description }} </span> <br>
                  <span style="font-size: 12px"> {{ $dayjs(item.createdAt).format('lll') }} </span>
                </v-list-item-content>

                <v-list-item-action>                 
                  <div style="padding-bottom: 10px">
                    <v-btn @click="remove(item.id)" color="white" small fab height="30px" width="30px">
                      <v-icon color="primary">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </div>
          </v-card>
        </v-col>
      
      <div class="text-center">
        <v-pagination v-model="page" :length="length"></v-pagination>
      </div>
    </div>
  </v-app>
</template>

<script>
import adminNotificationService from '@/services/admin/notifications';
import NotificationForm from '@/components/NotificationForm.vue';

export default {
  components: {
    NotificationForm,
  },
  created() {
    this.getNotifications();
  },
  computed: {
    imageDefaul() {
      return require('@/assets/images/avatar_dz.jpg');
    },
    length() {
      return Math.ceil(this.notifications.length / 5);
    },

    shownCards() {
      const { page, notifications } = this;
      const number = 5; // Numero de elementos a mostrar por página
      return notifications.slice((page - 1) * number, page * number);
    },
  },
  methods: {
    getNotifications() {
      adminNotificationService.fetchAll().then((response) => {
        this.notifications = response.data;
      });
    },
    remove(id) {
      this.$swal({
        title: '¿Desea eliminar esta notificación? ',
        text: 'Al eliminar la notificación se eliminará tamibién de las notificaciones del usuario',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, ¡eliminar notificación!',
        cancelButtonText: 'No, ¡cancelar!',
        reverseButtons: true,
      }).then(async (result) => {       
        if (result.isConfirmed) {
          adminNotificationService
          .remove(id)
          .then(() => {
            this.getNotifications();
          })
          .catch((error) => {
            if (error.response && [400, 409].includes(error.response.status)) {
              this.$swal('Error al eliminar notificación', error.response.data.message, 'warning');
            }
          });
        } else {
          this.$swal('Operación cancelada', 'No se eliminó la notificación seleccionada', 'error');
        }
      });      
    },
  },
  data() {
    return {
      page: 1,
      notifications: [],
    };
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
.subtitle {
  font-size:12px;
  font-weight: 600;
}
</style>